import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "./firebase.utils";


export async function useStartGoogleSignin(joinCode, successUrl, joinNew) {
    
    const provider = new GoogleAuthProvider();
    const path = await signInWithPopup(auth, provider)
    .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        if (successUrl) {
            return `/loading?successUrl=${successUrl}`;
        } else {
            return `/loading${joinCode ? `/${joinCode}` : ''}${joinNew ? `?join=true` : ''}`;
        }
            // IdP data available using getAdditionalUserInfo(result)
        // ...
    }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
    });

    return path;
}